import { RouteLocationRaw } from "vue-router";

export interface IMenu {
  heading: string;
  route: RouteLocationRaw;
  svgIcon?: string;
  meta?: {
    role: string[];
  };
  action?: string;
  sub?: IMenu[];
  queryParams?: {
    param: string;
    value: string;
  };
}

export const menu: IMenu[] = [
  {
    heading: "home",
    route: "/",
    svgIcon: "icon-home",
  },
  {
    heading: "my_bots",
    route: "/bots",
    svgIcon: "icon-bots",
  },
  {
    heading: "exchanges",
    route: "/exchanges",
    svgIcon: "icon-exchange",
  },
  {
    heading: "wallet",
    route: "/wallet",
    svgIcon: "icon-wallet",
  },
  {
    heading: "directory",
    route: "/guide",
    svgIcon: "icon-menu-docs",
  },
  {
    heading: "plan",
    route: "/plan",
    svgIcon: "icon-card",
  },
];
export const mobileMenu: IMenu[] = [
  ...menu,
  {
    heading: "settings",
    route: "/settings?profile=profile",
    svgIcon: "icon-settings",
  },
  {
    heading: "log_out",
    route: "",
    action: "logout",
    svgIcon: "icon-log-out !text-red",
  },
];

export const navigationMenu: IMenu[] = [
  {
    heading: "home",
    route: "/",
    name: "PDashboard",
    svgIcon: "icon-home",
  },
  {
    heading: "my_bots",
    route: "/bots",
    name: "Bots",
    svgIcon: "icon-bots",
  },
  {
    heading: "exchanges",
    route: "/exchanges",
    name: "Exchanges",
    svgIcon: "icon-exchange",
  },
  {
    heading: "wallet",
    route: "/wallet",
    name: "Wallet",
    svgIcon: "icon-wallet",
  },
  {
    heading: "plan",
    route: "/plan",
    name: "PlanPage",
    svgIcon: "icon-card",
  },
  {
    heading: "settings",
    route: "/settings",
    name: "Settings",
    queryParams: {
      param: "profile",
      value: "profile",
    },
    svgIcon: "icon-settings",
  },
];
